import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { BaseButtonsForm } from '@app/components/common/forms/BaseButtonsForm/BaseButtonsForm';
import { BaseFormItemProps } from '@app/components/common/forms/components/BaseFormItem/BaseFormItem';

interface EmailItemProps extends BaseFormItemProps {
  verified?: boolean;
  onClick?: () => void;
  readOnly?: boolean;
}

export const EmailItem: React.FC<EmailItemProps> = ({ required, readOnly, onClick, verified, ...props }) => {
  const { t } = useTranslation();

  return (
    <BaseButtonsForm.Item
      name="email"
      $isSuccess={verified}
      $successText={t('profile.nav.personalInfo.verified')}
      label={t('common.email')}
      rules={[
        { required: true, message: t('profile.nav.register.requiredEmail') },
        {
          type: 'email',
          message: t('common.notValidEmail'),
        },
      ]}
      {...props}
    >
      <BaseInput readOnly={!!readOnly} disabled={verified} onClick={onClick} />
    </BaseButtonsForm.Item>
  );
};
